var exports = {
  "Yy": "inlineReviewThreadHeading__-w62Ij",
  "ms": "ReviewThreadContainer__IjCC1q",
  "rK": "ResolvableContainer__tRHvwi",
  "DA": "ThreadLoading__1aeyDE",
  "uS": "resolvedIconButton__qul1wK",
};

module.exports = exports;
